module.exports = __webpack_public_path__ + "img/tickets.e0b0e2ce.svg";